export const SET_PROPERTY_ITEM = "SET_PROPERTY_ITEM";
export const ITEMS_RECIBIDOS = "ITEMS_RECIBIDOS";
export const SET_LAST_ITEM = "SET_LAST_ITEM";
export const CREATE_ITEM = "CREATE_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";
export const SET_ITEM = "SET_ITEM";
export const SET_ITEMS_BY_REVISION = "SET_ITEMS_BY_REVISION";

